"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALLBACKS_NAME = void 0;
var CALLBACKS_NAME = exports.CALLBACKS_NAME = {
  ON_LOG_SEARCH: 'onLogSearch',
  ON_REDIRECT_TO_OPERATOR_SITE_BY_SEARCH: 'onRedirectToOperatorSiteBySearch',
  ON_REDIRECT_TO_OPERATOR_SITE_BY_OFFER: 'onRedirectToOperatorSiteByOffer',
  ON_FAIL_SEARCH: 'onFailSearch',
  ON_SAVE_OFFER_TO_CLAIM: 'onSaveOfferToClaim',
  ON_FETCH_CLIENTS: 'onFetchClients',
  ON_GET_BOOKING_OPERATORS: 'onGetBookingOperators',
  ON_BOOKING_OFFER_BY_OPERATOR: 'onBookingOfferByOperator',
  ON_GET_COUNTRIES: 'onGetCountries',
  ON_REDIRECT_TO_BOOKINGS_PAGE: 'onRedirectToBookingsPage',
  ON_CLICK_BY_CONDITION_BOOKING_LINK: 'onClickByConditionBookingLink',
  ON_COPY_OFFER_TO_BUFFER: 'onCopyOfferToBuffer',
  ON_COPY_OFFER_FROM_BASKET_TO_BUFFER: 'onCopyOfferFromBasketToBuffer',
  ON_CLICK_BY_SEARCH_BUTTON: 'onClickBySearchButton',
  ON_CREATE_BASKET_WITH_OFFER_IN_MODAL: 'onCreateBasketWithOfferInModal',
  ON_GET_BASKETS: 'onGetBaskets',
  ON_GET_BASKETS_SIMPLIFIED: 'onGetBasketsSimplified',
  ON_ADD_BASKET_TO_CLAIM: 'onAddBasketToClaim',
  ON_CREATE_BASKET: 'onCreateBasket',
  ON_REMOVE_BASKET: 'onRemoveBasket',
  ON_SEND_BASKET: 'onSendBasket',
  ON_ADD_OFFER_TO_BASKET: 'onAddOfferToBasket',
  ON_UPDATE_OFFER_IN_BASKET: 'onUpdateOfferInBasket',
  ON_MOVE_OFFER_IN_BASKET: 'onMoveOfferInBasket',
  ON_REMOVE_OFFER_FROM_BASKET: 'onRemoveOfferFromBasket',
  ON_REMOVE_CLAIM_FROM_BASKET: 'onRemoveClaimFromBasket',
  ON_GET_BASKET_TEMPLATE: 'onGetBasketTemplate',
  ON_GENERATE_BASKET_PREVIEW: 'onGenerateBasketPreview',
  ON_UPDATE_BASKET: 'onUpdateBasket',
  ON_UPDATE_BASKET_STATUS: 'onUpdateBasketStatus',
  ON_GET_MANAGERS: 'onGetManagers',
  ON_COPY_OFFER_URL_TO_BUFFER: 'onCopyOfferURLToBuffer',
  ON_RECOGNIZE_PASSPORT: 'onRecognizePassport',
  ON_SHOW_OFFER: 'onShowOffer',
  ON_ACTUALIZED_OFFER: 'onActualizedOffer',
  ON_GET_PREVIOUS_BOOKINGS: 'onGetPreviousBookings',
  ON_GET_BOOKING_SERVICES: 'onGetBookingServices',
  ON_GET_SIMILAR_HOTELS: 'onGetSimilarHotels',
  ON_GET_INTEGRATION_SERVICES: 'onGetIntegrationServices',
  ON_RECALCULATE_BOOKING_SERVICES: 'onRecalculateBookingServices',
  ON_GET_BOOKING_COMPANIES: 'onGetBookingCompanies',
  ON_GET_BASKET_TEMPLATES: 'onGetBasketTemplates',
  ON_GET_OFFERS_REVIEWS_LINKS: 'onGetOffersReviewsLinks',
  ON_REQUEST_OPERATOR_LOGIN: 'onRequestOperatorLogin'
};